export default __webpack_public_path__ + "static/media/coworker-help.ac12c09a.png";